// extracted by mini-css-extract-plugin
export var backupIcon = "_sc-1";
export var image = "_sc-0";